var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 54,
    viewBox: "0 0 43 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3171_7508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.7447 11.3378C35.3668 11.3378 35.0646 11.4133 34.6867 11.4889C34.2333 9.97748 32.873 8.84391 31.1349 8.84391C30.1524 8.84391 29.17 9.22177 28.4899 9.90191C27.9609 8.54163 26.6006 7.63478 25.0892 7.63478C24.6357 7.63478 24.2579 7.71035 23.88 7.86149C23.7289 6.04778 22.2175 4.6875 20.4037 4.6875C18.3633 4.6875 16.7008 6.35007 16.7008 8.39049C16.7008 8.6172 16.7008 8.91949 16.7763 9.1462C16.3229 8.99506 15.8695 8.91949 15.416 8.91949C14.5092 8.91949 13.6779 9.22177 13.0733 9.82634C12.3932 8.99506 11.4108 8.46606 10.2772 8.46606C8.23679 8.46606 6.57422 10.1286 6.57422 12.169C6.57422 14.2095 8.23679 15.872 10.2772 15.872C11.1841 15.872 12.0153 15.5697 12.6199 14.9652C13.3001 15.7965 14.2825 16.3255 15.416 16.3255C17.4565 16.3255 19.119 14.6629 19.119 12.6225C19.119 12.3958 19.119 12.0935 19.0435 11.8668C19.4969 12.0179 19.9503 12.0935 20.4037 12.0935C20.8572 12.0935 21.235 12.0179 21.6129 11.8668C21.8396 13.6805 23.4266 15.0408 25.2403 15.0408C26.2227 15.0408 27.2052 14.6629 27.8853 13.9828C28.4143 15.343 29.7746 16.2499 31.286 16.2499C31.6639 16.2499 31.9661 16.1743 32.344 16.0987C32.7974 17.6102 34.1577 18.7437 35.8958 18.7437C37.9363 18.7437 39.5988 17.0812 39.5988 15.0408C39.4477 13.0003 37.7851 11.3378 35.7447 11.3378Z",
    fill: "#71DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.2873 5.96981C31.2873 6.80109 30.6071 7.5568 29.7003 7.5568C28.869 7.5568 28.1133 6.87666 28.1133 5.96981C28.1133 5.13852 28.7934 4.38281 29.7003 4.38281C30.6071 4.45838 31.2873 5.13852 31.2873 5.96981Z",
    fill: "#71DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5959 1.58699C22.5959 2.41828 21.9157 3.17399 21.0089 3.17399C20.1776 3.17399 19.4219 2.49385 19.4219 1.58699C19.4219 0.755712 20.102 0 21.0089 0C21.9157 0 22.5959 0.68014 22.5959 1.58699Z",
    fill: "#71DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.979 6.57347C13.979 7.0269 13.6011 7.40475 13.1477 7.40475C12.6943 7.40475 12.3164 7.0269 12.3164 6.57347C12.3164 6.12004 12.6943 5.74219 13.1477 5.74219C13.6011 5.74219 13.979 6.12004 13.979 6.57347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.2336 7.17819C21.6927 7.17819 22.0649 6.80601 22.0649 6.34691C22.0649 5.8878 21.6927 5.51562 21.2336 5.51562C20.7745 5.51562 20.4023 5.8878 20.4023 6.34691C20.4023 6.80601 20.7745 7.17819 21.2336 7.17819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.9907 1.05785C21.9907 1.51127 21.6128 1.88913 21.1594 1.88913C20.706 1.88913 20.3281 1.51127 20.3281 1.05785C20.3281 0.604418 20.706 0.226562 21.1594 0.226562C21.6128 0.226563 21.9907 0.604418 21.9907 1.05785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.0774 6.80319C30.5365 6.80319 30.9087 6.43101 30.9087 5.97191C30.9087 5.5128 30.5365 5.14062 30.0774 5.14062C29.6183 5.14062 29.2461 5.5128 29.2461 5.97191C29.2461 6.43101 29.6183 6.80319 30.0774 6.80319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M30.4563 11.4907C30.9154 11.4907 31.2876 11.1185 31.2876 10.6594C31.2876 10.2003 30.9154 9.82812 30.4563 9.82812C29.9972 9.82812 29.625 10.2003 29.625 10.6594C29.625 11.1185 29.9972 11.4907 30.4563 11.4907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M35.8949 51.2383H7.10233L2.03906 14.1328H40.9582L35.8949 51.2383Z",
    fill: "#FCB924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M36.7266 10.5769V14.1288H40.9585V10.5769C40.9585 9.44336 40.0517 8.46094 38.8426 8.46094C37.709 8.46094 36.7266 9.44336 36.7266 10.5769Z",
    fill: "#662520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.03906 10.5769V14.1288H6.27105V10.5769C6.27105 9.44336 5.36419 8.46094 4.15506 8.46094C2.94592 8.46094 2.03906 9.44336 2.03906 10.5769Z",
    fill: "#662520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M40.9583 14.1328H21.4609V51.2383H35.895L40.9583 14.1328Z",
    fill: "#E08605"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M40.9582 14.1328H2.03906V15.1908H40.9582V14.1328Z",
    fill: "#FCCA8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M35.9737 51.2344H7.10547V53.3504H35.9737V51.2344Z",
    fill: "#8C382D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M27.3585 12.9219H18.8945V30.7567H22.0685C23.8067 30.7567 25.1669 29.3964 25.1669 27.6583V15.0379C25.1669 14.5089 25.5448 14.131 26.0738 14.131H28.7944C28.6432 13.4509 28.0386 12.9219 27.3585 12.9219Z",
    fill: "#662520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M23.955 11.6406H10.8056C8.99189 11.6406 7.48047 13.152 7.48047 14.9658V37.1837C7.48047 39.1485 9.06746 40.66 10.9567 40.66H15.3399C17.3047 40.66 18.8161 39.073 18.8161 37.1837V16.1749C18.8161 14.3612 20.3276 12.8498 22.1413 12.8498H25.3908C25.3153 12.1696 24.7107 11.6406 23.955 11.6406Z",
    fill: "#8C382D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M21.4622 37.3351C9.59754 37.3351 0 27.5109 0 15.4195V12.2455C0 11.6409 0.453427 11.1875 1.058 11.1875C1.66257 11.1875 2.11599 11.6409 2.11599 12.2455V15.4195C2.11599 26.3773 10.8067 35.2191 21.5378 35.2191C32.2689 35.2191 40.9596 26.3017 40.9596 15.4195V12.2455C40.9596 11.6409 41.413 11.1875 42.0176 11.1875C42.6221 11.1875 43.0756 11.6409 43.0756 12.2455V15.4195C43 27.5109 33.3269 37.3351 21.4622 37.3351Z",
    fill: "#662520"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3171_7508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 53.3532,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.b9e88cc660a729b80b1287836d22e720.svg";
export { ForwardRef as ReactComponent };